<template>
    <div class="categories-bulk-selection-panel mb-3">
        <div class="font-weight-semibold mb-2">{{ $t('labels.create_integration_products_category_for_all') }}:</div>
        <div class="row">
            <div class="col-lg-5">
                <FormGroup :label="$t('labels.category_directory')" class="mb-0">
                    <AppSelect
                        :options="directoryOptions"
                        :model-value="selectedCategoryDirectory.value"
                        :selected-value="selectedCategoryDirectory.label"
                        @update:model-value="setDirectory"
                        option-key="value"
                        option-value="label"
                        :selected-values="disabledDirectories"
                    />
                </FormGroup>
            </div>
            <div class="col-lg-7 d-flex">
                <FormGroup :label="targetCategoryLabel" class="flex-fill mb-0">
                    <AppAutoComplete
                        v-if="selectedCategoryDirectory.value === CategoryDictionaryEnum.LOCAL"
                        :url="`/projects/${$route.params.projectUuid}/pim/channels/${targetIntegrationUuid}/categories`"
                        :model-value="targetIntegrationCategory?.uuid"
                        :selected-value="targetIntegrationCategory?.name"
                        @update:model-value="targetIntegrationCategory = $event"
                        :query-params="{
                            orders: [
                                {column : 'names->uk', dir : 'asc'}
                            ]
                        }"
                    />
                    <AppAutoComplete
                        v-else-if="selectedCategoryDirectory.value === CategoryDictionaryEnum.COMMON"
                        :url="`/projects/${$route.params.projectUuid}/marketplace/sources/${targetIntegrationService}/categories`"
                        :model-value="commonTargetIntegrationCategory?.uuid"
                        :selected-value="commonTargetIntegrationCategory?.name_uk"
                        @update:model-value="commonTargetIntegrationCategory = $event"
                        option-key="uuid"
                        option-value="name_uk"
                        :query-params="{
                            has_child: 0,
                            orders: [
                                {column : 'name_uk', dir : 'asc'}
                            ]
                        }"
                    />
                </FormGroup>
                <button
                    type="button"
                    class="btn btn-primary ml-2 align-self-end"
                    :disabled="isProcessing || selectedCount === 0 || !selectedCategory"
                    @click="apply"
                >
                    {{ $t('buttons.apply') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import AppSelect from '../../../../components/new/form/select/AppSelect.vue';
import AppAutoComplete from '../../../../components/new/form/autocomplete/AppAutoComplete.vue';

import { CategoryDictionaryEnum } from '../../../enums/CategoryDictionaryEnum';

export default {
    name: 'CategoriesBulkSelectionPanel',
    components: {
        FormGroup, AppSelect, AppAutoComplete
    },
    props: {
        directoryOptions: {
            type: Array,
            required: true
        },
        disabledDirectories: {
            type: Array,
            default: () => []
        },
        targetIntegrationService: {
            type: String,
            required: true
        },
        targetIntegrationUuid: {
            type: String,
            required: true
        },
        targetCategoryLabel: {
            type: String,
            required: true
        },
        isProcessing: {
            type: Boolean,
            default: false
        },
        selectedCount: {
            type: Number,
            default: 0
        },
    },
    emits: ['apply'],
    data() {
        return {
            CategoryDictionaryEnum,
            selectedCategoryDirectory: {
                value: CategoryDictionaryEnum.LOCAL,
                label: this.$t('labels.local'),
            },
            targetIntegrationCategory: null,
            commonTargetIntegrationCategory: null,
        };
    },
    methods: {
        setDirectory(value) {
            this.selectedCategoryDirectory = value;
            this.targetIntegrationCategory = null;
            this.commonTargetIntegrationCategory = null;
        },
        apply() {
            this.$emit('apply', {
                selectedCategoryDirectory: this.selectedCategoryDirectory,
                targetIntegrationCategory: this.targetIntegrationCategory,
                commonTargetIntegrationCategory: this.commonTargetIntegrationCategory,
            });
        },
    },
    computed: {
        selectedCategory() {
            return this.selectedCategoryDirectory.value === CategoryDictionaryEnum.LOCAL
                ? this.targetIntegrationCategory
                : this.commonTargetIntegrationCategory;
        },
    },
}
</script>
<style scoped>
.categories-bulk-selection-panel {
    padding: .75rem 1rem;
    background: #eff6ff;
    border: 1px solid #e5e7eb;
    border-radius: .35rem;
}
</style>
